function Map() {
  return (
    <>
    <main class="flex-shrink-0">
      <div class="container">
        <h2 class="mt-5">Map</h2>
        <p class="lead">
          The Map goes here.
        </p>
      </div>
    </main>
    </>
  );
}

export default Map;
